<div class="cardBloque">
    <div class="row w-100" style="margin: 0px">
        <div class="col-12 w-100" style="padding: 0px;">

            <h1 class="titleUs titlesSize">NOSOTROS <span [data-feather]="'users'" [class]="'mr-25;'" size="1em"></span>
            </h1>

            <div class="cardBloqueUs bg-primary text-white">
                <div class="imagen-centrada">
                    <img src="assets/images/logo/logo-ampi-blanco.png" style="height: 100px;" alt="AMPI">
                </div>
                <!-- <i class="fa fa-home" aria-hidden="true" style="font-size: 5rem;"></i> -->

                <div class="styleDescription mt-5">
                    <quill-view-html [ngClass]="{'text-container': true, 'expanded': isTextExpanded}"  [content]="this.usText"></quill-view-html>
                </div>
                <div class="text-center">
                    <button class="btn btn-primary" (click)="toggleTextExpansion()">
                        {{ isTextExpanded ? 'Ver menos' : 'Ver más' }}
                    </button>
                </div>
            </div>

            
        </div>
        <br>
        <br>
        <div class="mt-5 col-md-12 text-center">
            <a *ngIf="existeImagen" href="/pagina-adicional" class="text-center btn btn-primary">Conoce un poco mas</a>
            <img *ngIf="banderaDesplegar" src="{{imagen}}" style="max-width:100%;cursor:pointer" class="modal-hover-opacity" />
        </div>
        <div class="mt-5">
            <div class="col-md-4" *ngFor="let button of buttons">
                <a [href]="button.url"  target="_blank" class="btn btn-primary"> {{button.description}} </a>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" #closebutton class="close" data-dismiss="modal">&times;</button>
                <h4 class="modal-title">Mas informacion</h4>
            </div>
            <div class="modal-body">
                <img src="{{imagen}}" style="max-width:100%;cursor:pointer" class="modal-hover-opacity" />
            </div>
        </div>
    </div>
</div>